import { Col, Row } from 'reactstrap'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import CustomTable from 'components/CustomTable'
import InputCustom from 'components/Inputs'
import SimpleCard from 'components/SimpleCard'
import ModalExclusao from 'components/ModalExclusao'
import { RiFileEditLine } from 'react-icons/ri'
import { COLUMNS } from '../constants/columns'
import { CADASTRO_MODELO } from 'store/modules/backoffice/cadastroModelo/types'
import { ApplicationState } from 'store'
import { useSelector } from 'react-redux'
import useRedux from 'hooks/useRedux'
import * as cadastroModelosActions from 'store/modules/backoffice/cadastroModelo/actions'
import { useEffect } from 'react'

export default function Search() {
  const { pagination, showConfirmacaoExclusao, modeloMensagem, search } =
    useSelector<ApplicationState, CADASTRO_MODELO>(
      (state) => state.cadastroModelo
    )

  const { dispatch } = useRedux()

  function handleChange(value: string, field: string) {
    dispatch(cadastroModelosActions.setPesquisa(value, field))
  }

  function handleSearch() {
    if (!search.filtro?.trim()) {
      dispatch(cadastroModelosActions.getAllModeloMensagemSaga())
    } else {
      dispatch(cadastroModelosActions.getFiltrosSaga())
    }
  }

  function handleClear() {
    dispatch(cadastroModelosActions.setPesquisa('', 'filtro'))
    dispatch(cadastroModelosActions.getAllModeloMensagemSaga())
  }

  function setPage(value: number) {
    dispatch(
      cadastroModelosActions.setPaginacao({ ...pagination, page: value })
    )
    dispatch(cadastroModelosActions.getAllModeloMensagemSaga())
  }

  function setPageSize(value: number) {
    dispatch(
      cadastroModelosActions.setPaginacao({
        ...pagination,
        page: 0,
        pageSize: value
      })
    )
    dispatch(cadastroModelosActions.getAllModeloMensagemSaga())
  }

  useEffect(() => {
    dispatch(cadastroModelosActions.getAllModeloMensagemSaga())
  }, [dispatch])

  return (
    <SimpleCard>
      <Row>
        <Col>
          <SimpleTitleCard>
            <RiFileEditLine className="icon" />
            Modelo de Mensagens
          </SimpleTitleCard>
        </Col>
        <Col className="d-flex justify-content-end" md={3}>
          <CustomButton
            onClick={() =>
              dispatch(cadastroModelosActions.setActiveTab('register'))
            }
          >
            Cadastrar nova
          </CustomButton>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6}>
          <InputCustom
            type="text"
            placeholder="Pesquise aqui"
            onChange={(e) => handleChange(e.target.value, 'filtro')}
            value={search.filtro}
          />

          <div className="d-flex  gap-4 mt-3">
            <CustomButton
              onClick={handleClear}
              background="var(--roxo-riber)"
              color="#FFFF"
            >
              Limpar Filtro
            </CustomButton>
            <CustomButton onClick={handleSearch}>Pesquisar</CustomButton>
          </div>
        </Col>
      </Row>

      <Row>
        <CustomTable
          data={modeloMensagem}
          columns={COLUMNS}
          paginationMode="server"
          page={pagination.page}
          pageSize={pagination.pageSize}
          setPage={(e) => setPage(e)}
          setPageSize={(e) => setPageSize(e)}
          rowCount={pagination.totalRegistros}
        />
      </Row>

      <ModalExclusao
        isOpen={showConfirmacaoExclusao}
        toggle={(e) => cadastroModelosActions.toggleModalExclusaoDispatch(e)}
        onRemove={() => {
          cadastroModelosActions.deleteCadastroSagaDispatch()
        }}
      />
    </SimpleCard>
  )
}
